/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.feedback {
  display: flex;
  justify-content: space-between;
  appearance: none;
  border-radius: var(--radius-sm, 0.25rem);
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  border-style: var(--tw-border-style);
  border-width: 1px;
  border-color: transparent;
  align-items: flex-start;
}
.feedback.hasBorder {
  border-style: var(--tw-border-style);
  border-width: 1px;
  --tw-border-style: solid;
  border-style: solid;
  border-color: currentcolor;
}
.close {
  padding-inline: calc(var(--spacing, 0.25rem) * 4);
  padding-top: calc(var(--spacing, 0.25rem) * 4);
  border-radius: var(--radius-sm, 0.25rem);
  color: inherit;
  background-color: inherit;
  --tw-border-style: none;
  border-style: none;
  cursor: pointer;
}
.content {
  padding-inline: calc(var(--spacing, 0.25rem) * 4);
  padding-block: calc(var(--spacing, 0.25rem) * 3);
  display: grid;
  gap: calc(var(--spacing, 0.25rem) * 2);
  grid-template-columns: auto auto;
}
.content svg:first-of-type {
  margin-top: var(--spacing, 0.25rem);
}
.feedback.small .content {
  padding-inline: calc(var(--spacing, 0.25rem) * 3);
  padding-block: calc(var(--spacing, 0.25rem) * 2);
}
.feedback.xs .content {
  padding-inline: calc(var(--spacing, 0.25rem) * 2);
  padding-block: var(--spacing, 0.25rem);
  align-items: center;
}
.feedback.xs span, .feedback.xs div {
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  --tw-font-weight: var(--font-weight-bold, 700);
  font-weight: var(--font-weight-bold, 700);
}
.feedback.xs .content svg:first-of-type {
  margin-top: 0px;
}
.feedback.noIcon .content {
  grid-template-columns: auto;
}
.body {
  grid-column-start: 2;
  color: var(--color-emphasis-high, #000);
  --tw-font-weight: var(--font-weight-normal, 400);
  font-weight: var(--font-weight-normal, 400);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
}
.feedback.info-light .body, .feedback.info-dark .body {
  color: var(--color-emphasis-medium, #525252);
}
.feedback.noIcon .body {
  grid-column-start: 1;
}
.feedback.info-light {
  background-color: var(--color-neutral-light, #f5f5f5);
}
.feedback.info-dark {
  background-color: var(--color-neutral-dark, #404040);
  color: var(--color-neutral-light, #f5f5f5);
}
.feedback.loading-light, .feedback.success-light {
  background-color: var(--color-success-light, #dcfce7);
  color: var(--color-success-dark, #15803d);
}
.feedback.loading-dark, .feedback.success-dark {
  background-color: var(--color-success-dark, #15803d);
  color: var(--color-success-light, #dcfce7);
}
.feedback.error-light {
  background-color: var(--color-danger-light, #fef2f2);
  color: var(--color-danger-dark, #b91c1c);
}
.feedback.error-dark {
  background-color: var(--color-danger-dark, #b91c1c);
  color: var(--color-danger-light, #fef2f2);
}
.feedback.warning-light {
  background-color: var(--color-warning-light, #ffedd5);
  color: var(--color-warning-dark, #c2410c);
}
.feedback.warning-dark {
  background-color: var(--color-warning-dark, #c2410c);
  color: var(--color-warning-light, #ffedd5);
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-font-weight: initial;
      --tw-border-style: solid;
    }
  }
}
